export const ERouteName = {
  HOME: 'index',
  LOGGED_OUT: 'index',
  TNC: 'tnc',
  HELP_CENTER: 'help-center',

  LOBBY: 'lobby',
  PVP: 'playervsplayer',
  SoloPlay: 'soloplay',

  CONTACT_US: 'contact-us',
  PRIVACY_POLICY: 'privacypolicy',
  CHALLENGE_FRIENDS: 'challenge-friends',
  REFER_FRIENDS: 'referfriends',
  VIP_CLUB: 'vip-club',

  ACCOUNT: 'account',
  ACCOUNT_TRANSACTION_HISTORY: 'account-transaction-history-transactions',
  ACCOUNT_REFER: 'account-transaction-history-refer',
  ACCOUNT_PROFILE: 'account-profile',
  ACCOUNT_GAME_HISTORY: 'account-game-history',
  ACCOUNT_SOCIAL_GAMING: 'account-social-gaming',
  ACCOUNT_BLOCKED_USERS: 'account-blocked-users',

  WELCOME_OFFER: 'welcome-offer',
  BONUSES: 'bonuses',
  TOURNAMENTS_PAGE: 'tournaments-id',
} as const;
export type TRouteName = (typeof ERouteName)[keyof typeof ERouteName];
